// extracted by mini-css-extract-plugin
export default {"Process":"style_Process__Qt85g","ProcessWrap":"style_ProcessWrap__qumju","subheading":"style_subheading__JoETH"};